<template>
  <div id="video-player">
    <div class="video-container">
      <img src="http://pic1.win4000.com/wallpaper/e/57a2d4c6d1aef.jpg" alt="" />
      <span @click="handleVideoClick" class="iconfont icon">&#xe651;</span>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
      top="15px"
    >
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </el-dialog>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";

import { videoPlayer } from "vue-video-player";
export default {
  name: "VideoPlayer",
  components: {
    videoPlayer
  },
  data() {
    return {
      dialogVisible: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "http://vjs.zencdn.net/v/oceans.mp4" //url地址
          }
        ],
        poster: "http://pic1.win4000.com/wallpaper/e/57a2d4c6d1aef.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$refs.videoPlayer.player.pause();
      this.$refs.videoPlayer.player.src("http://vjs.zencdn.net/v/oceans.mp4");
    },
    handleVideoClick() {
      this.dialogVisible = true;
      let that = this;
      setTimeout(() => {
        that.$refs.videoPlayer.player.play();
      }, 300);
    }
  }
};
</script>

<style lang="scss" scoped>
#video-player {
  width: 50%;
  margin-right: 10px;
  .video-container {
    width: 100%;
    height: 423px;
    background: #9e9e9e;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .icon {
      cursor: pointer;
      font-size: 64px;
      color: #9e9e9e;
      opacity: 0.8;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 50%;
      margin-top: -50px;
    }
  }
}
.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}
.vjs-big-play-button {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: center;*/
}
</style>
